import { Data, Model, Utils } from "@singularsystems/neo-core";
import { AxiosPromise } from "axios";
import { injectable } from "inversify";
import { AppService, Types } from "../../App/Services/AppService";
import CommandResult from "../../Common/Models/CommandResult";
import SaveFileGroupingImportProcedureCommand from "../FileGroupingFileSpecImportProcedures/Models/Commands/SaveFileGroupingImportProcedureCommand";
import FileGroupingFileSpecImportProcedureLookup from "../FileGroupingFileSpecImportProcedures/Models/Lookups/FileGroupingFileSpecImportProcedureLookup";
import ImportProcedureLookup from "../FileGroupingFileSpecImportProcedures/Models/Lookups/ImportProcedureLookup";
import ProcessTypeLookup from "../FileGroupingFileSpecImportProcedures/Models/Lookups/ProcessTypeLookup";
import FileGroupingFileSpecImportProcedureCriteria from "../FileGroupingFileSpecImportProcedures/Models/Queries/FileGroupingFileSpecImportProcedureCriteria";
import GetImportProcedureListQuery from "../FileGroupingFileSpecImportProcedures/Models/Queries/GetImportProcedureListQuery";

export interface IFileGroupingFileSpecImportProcedureApiClient {
    getFileGroupingFileSpecImportProcedures(request: Model.PartialPlainNonTrackedObject<Data.PageRequest<FileGroupingFileSpecImportProcedureCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<FileGroupingFileSpecImportProcedureLookup>>>;
    getImportProcedures(request: Model.PlainObject<GetImportProcedureListQuery>): AxiosPromise<Array<Model.PlainObject<ImportProcedureLookup>>>;
    getProcessTypeList(): AxiosPromise<Array<Model.PlainObject<ProcessTypeLookup>>>;
    saveFileGroupingImportProcedure(command: Model.PlainObject<SaveFileGroupingImportProcedureCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
}

@injectable()
export default class FileGroupingFileSpecImportProcedureApiClient extends Data.ApiClientBase implements IFileGroupingFileSpecImportProcedureApiClient {
    constructor(config = AppService.get(Types.Config)) {
        super(`${config.apiPath}/FileGroupingFileSpecImportProcedures`)
    }

    public getFileGroupingFileSpecImportProcedures(request: Model.PartialPlainNonTrackedObject<Data.PageRequest<FileGroupingFileSpecImportProcedureCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<FileGroupingFileSpecImportProcedureLookup>>> {
        return this.axios.get(`${this.apiPath}/GetFileGroupingFileSpecImportProcedures?${Utils.getQueryString(request)}`);
    }

    public getImportProcedures(request: Model.PlainObject<GetImportProcedureListQuery>): AxiosPromise<Array<Model.PlainObject<ImportProcedureLookup>>> {
        return this.axios.get(`${this.apiPath}/GetImportProceduresList?${Utils.getQueryString(request)}`);
    }

    public getProcessTypeList(): AxiosPromise<Array<Model.PlainObject<ProcessTypeLookup>>> {
        return this.axios.get(`${this.apiPath}/GetProcessTypeList`);
    }

    public saveFileGroupingImportProcedure(command: Model.PlainObject<SaveFileGroupingImportProcedureCommand> ): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/SaveFileGroupingImportProcedure`, command);
    }
}